import { compareTime } from "./compareTime.js";
function timePeriodsEqual(period1, period2) {
  if (period1 && period2) {
    const [start1, end1] = period1;
    const [start2, end2] = period2;
    return compareTime(start1, start2) === 0 && compareTime(end1, end2) === 0;
  }
  return !period1 && !period2;
}
export {
  timePeriodsEqual
};
